import { Injectable, OnDestroy } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  	providedIn: 'root'
})

export class Layout implements OnDestroy {
	private readonly _mobileQuery: MediaQueryList;
	private readonly _mobileQueryListener: () => void;
	private _isMobileSubject = new BehaviorSubject<boolean>(false);
	public readonly isMobile$: Observable<boolean> = this._isMobileSubject.asObservable();

  	constructor(private mediaMatcher: MediaMatcher) {
		this._mobileQuery = this.mediaMatcher.matchMedia('(max-width: 600px)');
		this._isMobileSubject.next(this._mobileQuery.matches);
		this._mobileQueryListener = () => this._isMobileSubject.next(this._mobileQuery.matches);
		this._mobileQuery.addEventListener('change', this._mobileQueryListener);
	}

	ngOnDestroy(): void {
		this._mobileQuery.removeEventListener('change', this._mobileQueryListener);
	}
}